import { put, select, take, takeEvery } from 'redux-saga/effects';

import { MESSAGE_TYPES } from '../../../constants/chat';
import chatConsts from '../../chatConnection/constants';
import { actions as chatActions } from '../../chatConnection';
import { selectTeamId, selectTeamUserId } from '../../context/selectors';
import { actions as createInboxTask } from '../create-chat-inbox-task-req';
import {
  activeChannelSelector,
  activeChannelIdSelector,
  activeContextChannelSelector,
} from '../../chatConnection/selectors';

function* sendMessageWithInboxTaskSWorker({ payload }) {
  const {
    type,
    files,
    message,
    important,
    linkPayload,
    quoteMessageId,
  } = payload;

  const channel = yield select(activeChannelSelector);
  const channelId = yield select(activeChannelIdSelector);
  const contextChannel = yield select(activeContextChannelSelector);
  const { inboxTaskId: channelTaskId, needsInboxTask } = { ...contextChannel };
  let inboxTaskId = channelTaskId;

  if (needsInboxTask && !inboxTaskId) {
    yield put(createInboxTask.send({ chatRoomAppId: channelId }));

    const { payload: taskPayload } = yield take(createInboxTask.succeed);

    const { inboxTaskId: currentTaskId } = taskPayload;
    inboxTaskId = currentTaskId;
  }

  const data = {
    message,
    important,
    inboxTaskId,
    quoteMessageId,
  };

  if (type === MESSAGE_TYPES.ATTACHMENT) {
    const teamId = yield select(selectTeamId);
    const teamUserId = yield select(selectTeamUserId);

    yield put(
      chatActions.uploadAttachment({
        ...data,
        files,
        teamId,
        channel,
        teamUserId,
      }),
    );
  } else {
    yield put(
      chatActions.sendMessage({
        ...data,
        channelId,
        linkPayload,
      }),
    );
  }
}

export default function* sendMessageWithInboxTaskSaga() {
  yield takeEvery(
    [chatConsts.SEND_MESSAGE_WITH_INBOX_TASK],
    sendMessageWithInboxTaskSWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/send-message-with-inbox-task-saga.js